/**
 * Helpers
 */

const selectors = {
    mobileNavigation: '.js-mobile-navigation',
    navToggle: '.js-nav-toggle',
    navItem: '.js-nav-item',
    body: 'body'
};

const classes = {
    isActive: 'nav-active',
    isRevealed: 'is-revealed'
};

/**
 * Main
 */
const toggle = document.querySelector(selectors.navToggle);
const body = document.querySelector(selectors.body);

const mobileNavigation = document.querySelector(selectors.mobileNavigation);
const navItems = [...mobileNavigation.querySelectorAll(selectors.navItem)];

// get vendor transition property
const docElemStyle = document.documentElement.style;
const transitionProp =
    typeof docElemStyle.transition == 'string' ? 'transition' : 'WebkitTransition';

let isOpen = false;

toggle.addEventListener('click', () => {
    if (isOpen) {
        navItems
            .slice()
            .reverse()
            .forEach((item, index) => {
                item.style[transitionProp + 'Delay'] = index * 100 + 'ms';
                item.classList.remove(classes.isRevealed);
            });
        setTimeout(() => {
            body.classList.remove(classes.isActive);
        }, 600);

        // Toggle close the open nav items
        const openSubnavs = [...mobileNavigation.querySelectorAll('.js-reveal.is-open')];

        if (openSubnavs.length) {
            openSubnavs.forEach((nav) => {
                nav.dispatchEvent(new Event('click'));
            });
        }
        isOpen = false;
    } else {
        body.classList.add(classes.isActive);
        setTimeout(() => {
            navItems.forEach((item, index) => {
                item.style[transitionProp + 'Delay'] = index * 100 + 'ms';
                item.classList.add(classes.isRevealed);
            });
        }, 400);

        isOpen = true;
    }
});
